import * as React from "react";
import Component from "../../../../AbstractComponent";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import TextField from "../../../../Partials/Material/TextField";
import Searchbar from "../../../Searchbar/Searchbar";

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "../../NewCoach/NewCoachContents/CoachSummaryTable";

export class CounterpartyStep extends Component {

  public renderSummary = () => {
    let summaryArr = [];

    if (this.props.tenantType === "company") {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newcompany-label"),
        value: this.props.companyTenant?.displayName
      })
    }
    if (this.props.tenantType === "person") {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newperson-label"),
        value: this.props.tenant?.displayName
      })
    }

    return summaryArr;
  }

  render() {
    const { coachType } = this.props;
    let labelText = '';
    if (coachType === "Receivable") {
      labelText = this.trans('charge-class-receivable');
    }
    if (coachType === "Payable") {
      labelText = this.trans('charge-class-payable');
    }
    if (coachType === "registerIncomingInvoice") {
      labelText = this.trans('charge-class-invoice');
    }

    if(this.props.counterpartySuccessfullyCreated && (this.props.tenant || this.props.companyTenant) && this.props.tenantChoice === "newtenant"){  
        return (
          <div className="coach-content-wrapper">
            <Title
              title={this.props.coachType === "Receivable" ? this.trans("coach/counterpartystep/receivable/title") : this.trans("coach/counterpartystep/payable/title")}
            />
            <Subtitle
              subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", {entity: this.trans("label-counterparty").toLowerCase()})}
            />
            <CoachSummaryTable
              tableRows={this.renderSummary()}
            /> 
          </div>
        );
      } else {
        return (
          <div className="coach-content-wrapper">
            <Title
              title={this.props.coachType === "Receivable" ? this.trans("coach/counterpartystep/receivable/title") : this.trans("coach/counterpartystep/payable/title")}
              style={{marginBottom: "40px"}}
            />
            {
              <RadioGroup
                name="chargeOwnerChoice"
                className="filters-container"
                value={this.props.tenantChoice}
                onChange={this.props.changeTenantChoice}
              >
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="existingtenant"
                  label={this.trans("coach/knowncounterparty/first-title")}
                  style={{width: "auto", fontSize: "16px"}}
                />
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="newtenant"
                  label={this.trans("coach/newcounterparty-step/first-title")}
                  style={{width: "auto", fontSize: "16px"}}
                />
              </RadioGroup>
              }
              
              { this.props.tenantChoice === "existingtenant" ?
                <div className="search-bar-container">
                  <Searchbar
                    {...this.props}
                    name="personId"
                    className="scroll-to-mainTenantContactId"
                    id="selectedTenantForContract"
                    ref="TenantLookup"
                    floatingLabelText={labelText}
                    allResults={true}
                    objectField={true}
                    onChange={this.props.selectCounterpartyForCharge}
                    onClear={this.props.clearCounterpartyForCharge}
                    selectedEntity={this.props.selectedCounterpartyForCharge}
                    searchParameter={"contactsSearch"}
                    error={this.props.counterpartyError && this.trans(this.props.counterpartyError)}
                    searchText={this.props.selectedCounterpartyForCharge ? `${this.props.selectedCounterpartyForCharge?.nameOfEntity}, ${this.props.selectedCounterpartyForCharge?.displayName}` : null}
                    styleInModal={"pick-object-modal"}
                  />
                </div>
                :
                <div>
                  <RadioGroup
                    className="filters-container"
                    value={this.props.tenantType}
                    onChange={this.props.chooseTenantType}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      paddingLeft: "0px"
                    }}
                  >
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      value="person"
                      label={this.trans("coach/propertyowner-radiobutton/person")}
                      style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
                    />
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      value="company"
                      label={this.trans("coach/propertyowner-radiobutton/company")}
                      style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
                    />
                  </RadioGroup>
                  { this.props.tenantType === "person" &&
                    <div>
                      <div style={{display: "flex", width: "100%"}}>
                        <div style={{ width: "600px", marginRight: "20px"}}>
                          <TextField
                            autoComplete="off"
                            // id="firstName"
                            // name="firstName"
                            className="form-element full-size scroll-to-firstName"
                            type="text"
                            autoFocus={true}
                            label={this.trans("label-first-name")}
                            value={this.props.tenantFirstName}
                            onChange={(e) => this.props.handleInputChange(e, 'tenantFirstName')}
                            variant="standard"
                            error={this.props.counterpartyError && this.trans(this.props.counterpartyError)}
                          />
                        {(!!this.getErrorFor("firstName") && !this.props.occupantError) && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}  
                        </div>  
                      <TextField
                        autoComplete="off"
                        // id="lastName"
                        // name="lastName"
                        className="form-element full-size scroll-to-lastName"
                        type="text"
                        label={this.trans("label-last-name") + this.trans("field/optional")}
                        value={this.props.tenantLastName}
                        onChange={(e) => this.props.handleInputChange(e, 'tenantLastName')}
                        variant="standard"
                        error={this.props.counterpartyError && this.trans(this.props.counterpartyError)}
                      />
                    </div>
                  </div>
                  }
                  {
                    this.props.tenantType === "company" && 
                    <div>
                       <TextField
                        autoComplete="off"
                        className="form-element full-size"
                        type="text"
                        label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                        value={this.props.companyNameTenant}
                        onChange={(e) => this.props.handleInputChange(e, 'companyNameTenant')}
                        variant="standard"
                        autoFocus={true}
                        error={this.props.counterpartyError && this.trans(this.props.counterpartyError)}
                      />
                      {!!this.getErrorFor("name") && <div className="component-error-text">{this.props.counterpartyError && this.trans(this.props.counterpartyError)}</div>}  
                    </div>
                  }
    
                  <div className="coach-new-property-save-button">
                    <Button
                      color="primary"
                      onClick={this.props.createTenant}
                      variant="contained"
                      style={{textAlign: "right"}}
                    >
                      {this.trans("button-save")}
                    </Button>
                  </div>
                </div>
              }              
          </div>
        )
      }
  }
}